module.exports = "<div class=\"q-ib-container q-marg-top-lg q-icon-box q-icon-box-{%- statusColor %}\"> <div class=q-ib-icon-wrap> <i class=\"q-ib-icon fa fa-{%- icon %}\"></i> </div> <div class=q-ib-content> <div class=q-ibc-title-row> <div class=q-ibc-item>Status: {%- status %}</div> </div> <div class=q-ibc-detail-row> <div class=q-ibc-item>Date: {%- date %}</div> <div class=q-ibc-item>City: {%- city %}</div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/proofOfDelivery/podPackageDetailsScreen/html/statusHistoryRow.html
// module id = 1385
// module chunks = 1